export default __webpack_public_path__ + "static/sub-account2-8aac4cb040ead8fa51fff313a8ad2c99.png";